export function quoteSmallSlider() {
    const $slider = $(".quote-small-slider");
    $slider.each(function () {
        let $this = $(this);
        $this.slick({
            slidesToScroll: 1,
            slidesToShow: 1,
            infinite: true,
            arrows: false,
            fade: true,
            dots: true,
            mobileFirst: true,
            adaptiveHeight: true,
        });
        if ($this.parents(".media").length) {
            let $parent = $this.parents(".media");
            let $img = $parent.find("img");
            $parent.addClass("has-quote-slider");
            $img.first().addClass("active");
            $this.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                if ($img.eq(nextSlide).length) {
                    $img.removeClass("active");
                    $img.eq(nextSlide).addClass("active");
                }
            });
        }
    });
    $slider.on("click", function () {
        $(this).slick("slickNext");
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/quoteSmallSlider.js